import type React from 'react';

import { Grid } from '@change/ds-layout';

import { DismissButton } from '../shared/components/DismissButton';
import { useBanner } from '../shared/hooks/useBanner';

import { Content } from './components/Content';
import { PhoneImage } from './components/PhoneImage';
import { QRCode } from './components/QRCode';

const BANNER_GRADIENT =
	'linear-gradient(56deg, rgb(254, 242, 242) 0%, rgb(255, 250, 237) 29%, rgb(255, 255, 235) 100%)';

type Props = {
	sourceLocation: string;
	setBannerClosed: () => void;
};

export const DesktopBanner: React.FC<Props> = ({ sourceLocation, setBannerClosed }) => {
	const {
		actions: { onClickClose },
	} = useBanner({ sourceLocation, setBannerClosed });

	return (
		<div
			id="app-download-bottom-banner-v2"
			className="fixed bottom-0 left-0 z-30 hidden w-full border-t border-solid border-[#e1dde9] py-9 shadow-[0px_10px_20px_0px_rgba(24,25,31,0.1)] md:block"
			style={{ backgroundImage: BANNER_GRADIENT }}
			data-testid="app-download-bottom-banner-v2"
			role="alert"
		>
			<DismissButton className="absolute top-6 right-6 z-1" onClick={onClickClose} />
			<Grid className="items-center py-4">
				<div className="col-span-4 md:col-span-2">
					<QRCode />
				</div>
				<div className="col-span-4 md:col-span-5 lg:col-span-7">
					<Content />
				</div>
				<div className="hidden justify-self-end lg:col-span-3 lg:block">
					<PhoneImage />
				</div>
			</Grid>
		</div>
	);
};
